// extracted by mini-css-extract-plugin
export var option = "_72-0";
export var optionCard = "_72-f";
export var optionContent = "_72-g";
export var optionIcon = "_72-i";
export var optionIconBox = "_72-h";
export var optionLabel = "_72-j";
export var optionPill = "_72-m";
export var optionPillBadge = "_72-p";
export var optionPillIcon = "_72-n";
export var optionPillLabel = "_72-o";
export var optionRadio = "_72-k";
export var optionRadioInner = "_72-l";
export var optionReveal = "_72-2";
export var optionRevealDelay0 = "_72-3";
export var optionRevealDelay1 = "_72-4";
export var optionRevealDelay10 = "_72-d";
export var optionRevealDelay11 = "_72-e";
export var optionRevealDelay2 = "_72-5";
export var optionRevealDelay3 = "_72-6";
export var optionRevealDelay4 = "_72-7";
export var optionRevealDelay5 = "_72-8";
export var optionRevealDelay6 = "_72-9";
export var optionRevealDelay7 = "_72-a";
export var optionRevealDelay8 = "_72-b";
export var optionRevealDelay9 = "_72-c";
export var optionSelected = "_72-1";